const SectionOrganizerConstants = {
  SELF_SERVE_BUILDER_SECTION_ORGANIZER_FIELD_ADD: 'SELF_SERVE_BUILDER_SECTION_ORGANIZER_FIELD_ADD',
  SELF_SERVE_BUILDER_SECTION_ORGANIZER_FIELD_REMOVE: 'SELF_SERVE_BUILDER_SECTION_ORGANIZER_FIELD_REMOVE',
  SELF_SERVE_BUILDER_SECTION_ORGANIZER_SECTION_ADD: 'SELF_SERVE_BUILDER_SECTION_ORGANIZER_SECTION_ADD',

  SELF_SERVE_BUILDER_SECTION_ORGANIZER_FIELD_MOVE: 'SELF_SERVE_BUILDER_SECTION_ORGANIZER_FIELD_MOVE',
  SELF_SERVE_BUILDER_SECTION_ORGANIZER_SECTION_REMOVE: 'SELF_SERVE_BUILDER_SECTION_ORGANIZER_SECTION_REMOVE',
  SELF_SERVE_BUILDER_SECTION_ORGANIZER_SECTION_RENAME: 'SELF_SERVE_BUILDER_SECTION_ORGANIZER_SECTION_RENAME',
  SELF_SERVE_BUILDER_SECTION_ORGANIZER_SECTION_MOVE: 'SELF_SERVE_BUILDER_SECTION_ORGANIZER_SECTION_MOVE',
  SELF_SERVE_BUILDER_SECTION_ORGANIZER_SECTION_SPLIT: 'SELF_SERVE_BUILDER_SECTION_ORGANIZER_SECTION_SPLIT',

};

export default SectionOrganizerConstants;



// WEBPACK FOOTER //
// ./src-react/SelfServePostBuilderSidePanel/SectionOrganizer/SectionOrganizerConstants.jsx